<template>
  <section id="cursos">
    <p class="intro">
      Confira a disponibilidade de cursos ofertados no momento através da nossa página.
    </p>
    <h2>Cursos e Capacitações</h2>
    <div class="cards">
      <Card
        v-for="(curso, index) in cursos"
        :key="index"
        :title="curso.title"
        link="https://www.sympla.com.br/samatech"
        subtitle="SAMATech"
      >
        <img :src="require('@/assets/img/cursos/' + curso.img)" alt="" />
      </Card>
    </div>
  </section>
</template>

<style scoped lang="scss">
.cards {
  padding: 0 2em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  justify-content: space-evenly;
  margin: auto;
  @media screen and (max-width: 450px) {
    padding: 0 0.5em;
  }
}
h2 {
  text-align: center;
}
.intro {
  text-align: center;
  max-width: 100ch;
  margin: auto;
  padding: 4em 2em 1em 2em;
}
</style>

<script>
import Card from "@/components/cursos/CardCurso.vue";
export default {
  components: {
    Card
  },
  data() {
    return {
      cursos: [
        {
          title: "Acessos Vasculares <br>(Punção Venosa)",
          img: "Acessos_Vasculares.png"
        },
        {
          title: "Pacientes de Alta Complexidade",
          img: "Pacientes_de_Alta_Complexidade.jpg"
        },
        {
          title: "Suporte Básico de Vida (BLS)",
          img: "Suporte_Basico_de_Vida.png"
        },
        {
          title: "Tratamento de Feridas e Curativos",
          img: "Tratamento_de_Feridas_e_Curativos.jpg"
        },
        {
          title: "Cuidados ao Paciente Ostomizado",
          img: "Cuidados_ao_Paciente_Ostomizado.jpg"
        },
        {
          title: "Análise em Eletrocardiogramas",
          img: "Analise_em_Eletrocardiogramas.jpg"
        },
        {
          title: "Técnicas de Coleta de Sangue",
          img: "Tecnicas_de_Coleta_de_Sangue.jpg"
        },
        {
          title: "Interpretação de Exames Laboratoriais",
          img: "Interpretacao_de_Exames_Laboratoriais.jpg"
        },
        {
          title: "Imunização (Vacinas)",
          img: "Imunizacao.png"
        },
        {
          title: "Capacitação Prática em Emergência",
          img: "Capacitacao_Pratica_em_Emergencia.jpg"
        },
        {
          title: "Capacitação em Centro Cirúrgico",
          img: "Capacitacao_em_Centro_Cirurgico.jpg"
        },
        {
          title: "Biossegurança",
          img: "Biosseguranca.jpg"
        },
        {
          title: "Emergência Pediátrica",
          img: "Emergencia_Pediatrica.jpg"
        },
        {
          title: "Treinamento de Teste Rápido para HIV e outras IST's",
          img: "Treinamento_de_Teste_Rapido_para_HIV_e_outras_ISTs.jpg"
        },
        {
          title: "Saúde e Meio Ambiente",
          img: "Saude_e_Meio_Ambiente.jpg"
        },
        {
          title: "Controle de Resíduos Hospitalares",
          img: "Controle_de_Residuos_Hospitalares.jpg"
        },
        {
          title: "Curso de Excel <br>(Básico e Intermediário)",
          img: "Curso_de_Excel.png"
        },
        {
          title: "Capacitação em Informática Básica",
          img: "Capacitacao_em_Informatica_Basica.jpg"
        },
        {
          title: "Preparatório para Concursos",
          img: "SUS_para_Concursos.jpg"
        },
        {
          title: "Primeiros Socorros",
          img: "Primeiros_Socorros.jpg"
        },
        {
          title: "Qualificação ao Cuidado do Idoso",
          img: "Qualificacao_ao_Cuidado_do_Idoso.jpg"
        },
        {
          title: "Farmacologia com Cálculo de Medicamentos",
          img: "Farmacologia_com_Calculo_de_Medicamentos.jpg"
        },
        {
          title: "Ventilação Mecânica",
          img: "Ventilacao_Mecanica.jpg"
        },
        {
          title: "Noções Radiológicas para Enfermagem",
          img: "Nocoes_Radiologicas_para_Enfermagem.jpg"
        }
      ]
    };
  }
};
</script>
